export const  ExpensesColumns = [
    "SNo",
    "Head",
    "Category",
    "Month",
    "Amount"
];
